export default {
  BOLS: "/bols",
}
